import { AppRecord } from '$tablet-app/src/app/app_library/types';
import { Linking } from 'react-native';
import SendIntentAndroid from 'react-native-send-intent';
import canOpenApp from './canOpenApp/canOpenApp';

const openApp = async (app: AppRecord) => {
  if (!(await canOpenApp(app))) {
    return false;
  } else if (app.package_name) {
    return SendIntentAndroid.openApp(app.package_name, {});
  } else if (app.url) {
    return await Linking.openURL(app.url);
  } else {
    return false;
  }
};

export default openApp;
